import {  reporting_dashboard } from "../../services/api"
import { GET__HIGEST_POLL, POLL_RESULT_CLEAR, ERR__HIGEST_POLL, GET_POLL_ANALYSIS, LOADING__POLL_ANALYSIS, ERR__GET__POLL_ANALYSIS } from "./actionTypes"

export const getMostPopularpoll = () => async (dispatch) => {
    try {
        const response = await reporting_dashboard("/highest-poll", "GET");
        
        if (response.status === 200) {
            dispatch({
                type: GET__HIGEST_POLL,
                payload: response.data
            })
        }
    } catch (err) {
        dispatch({
            type: ERR__HIGEST_POLL,
            payload: err.response?.msg || "Something went wrong",
        })
    }
}
export const getpollanalytics = (values) => async (dispatch) => {
    try {
  const { campaign_id, end_date, question, start_date } = values;

const data = {
  campaignId: campaign_id,
  endDate: end_date,
  startDate: start_date,
  ...(question !== "" && { question })
};


        const response = await reporting_dashboard("/getpollData", "POST", data);        
        if (response.status === 200) {
            dispatch({
                type: GET_POLL_ANALYSIS,
                payload: response.data
            })
        }
    } catch (err) {
        
        dispatch({
            type: ERR__GET__POLL_ANALYSIS,
            payload: err.response?.data?.message || "Something went wrong",
        })
    }
}
export const clearPollResult = (values) => async (dispatch) => {
    try {
 
        if(values === true){
  dispatch({
                type: POLL_RESULT_CLEAR,
                payload: values
            })
        }
          
        
    } catch (err) {
        dispatch({
            type: ERR__GET__POLL_ANALYSIS,
            payload: err.response?.msg || "Something went wrong",
        })
    }
}